(() => {
  "use strict";

  const openClass = "is-product-guide-open";
  const targetPopupIds = ["popup1", "popup2"];

  const setOpenState = (isOpen) => {
    document.documentElement.classList.toggle(openClass, isOpen);
    document.body.classList.toggle(openClass, isOpen);
  };

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest(".openPopup");

    if (trigger) {
      const targetId = trigger.getAttribute("data-target");

      if (targetPopupIds.includes(targetId)) {
        setOpenState(true);
      }

      return;
    }

    const closeButton = event.target.closest(".closePopup");

    if (closeButton) {
      const popup = closeButton.closest(".popup");

      if (popup && targetPopupIds.includes(popup.id)) {
        setOpenState(false);
      }

      return;
    }

    if (
      event.target.id === "overlay" &&
      document.body.classList.contains(openClass)
    ) {
      setOpenState(false);
    }
  });

  document.addEventListener("keydown", (event) => {
    if (
      event.key === "Escape" &&
      document.body.classList.contains(openClass)
    ) {
      setOpenState(false);
    }
  });
})();